import { Box, Button } from '@mui/material'
import React from 'react'

const SettingsFooter = ({ saveButton, cancelButton }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
      {cancelButton && (
        <Button sx={{ mr: 2 }} {...cancelButton}>
          {cancelButton.label || 'Cancel'}
        </Button>
      )}
      {saveButton && (
        <Button variant={'contained'} {...saveButton}>
          {saveButton.label || 'Save'}
        </Button>
      )}
    </Box>
  )
}

export default SettingsFooter
